import type { SurveyAnswer } from 'components/surveys/responses/surveyResponses'

export type { SurveyAnswer }

export interface ApiSurveyAnswer {
  question_id: number
  answer: string | null
}

export const toApiSurveyAnswer = (a: SurveyAnswer): ApiSurveyAnswer => ({
  question_id: a.questionId,
  answer: a.answer
})

export interface ApiSurveyResponseResponse {
  id: number
  answers: ApiSurveyAnswer[]
  submitted_at: string | null
}

export interface SurveyResponseData {
  id: number
  answers: SurveyAnswer[]
  submittedAt: string | null
}

export const toSurveyResponseData = (response: ApiSurveyResponseResponse): SurveyResponseData => ({
  id: response.id,
  answers: response.answers.map(a => ({ questionId: a.question_id, answer: a.answer })),
  submittedAt: response.submitted_at
})
